import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(persist((set, get) => ({
  user: null,
  trabajador: null,
  franquiciado: null,
  token: null,
  isAuthenticated: false,
  setUser: (userData) => {
    set({
      user: {
        ...userData,
      },
      token: userData.token,
      isAuthenticated: true
    });
  },
  setTrabajador: (trabajadorData) => {
    set({
      trabajador: {
        ...trabajadorData,
      },
      token: trabajadorData.token,
      isAuthenticated: true
    });
  },
  setFranquiciado: (franquiciadoData) => {
    set({
      franquiciado: {
        ...franquiciadoData,
      },
      token: franquiciadoData.token,
      isAuthenticated: true
    });
  },
  logout: () => set({
    user: null,
    trabajador: null,
    franquiciado: null,
    token: null,
    isAuthenticated: false
  })
}), {
  name: 'auth-storage-petitprime',  // The key in localStorage
  getStorage: () => localStorage  // Specify localStorage as the storage location
}));

export default useAuthStore;
